export enum Severity {
  Mandatory = 10,
  Error = 20,
  Warning = 40,
  Info = 50,
  None = 60,
}
